import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getCurrentRouteAndParams, getIsPageBlocked } from '../../App';
import { triggerPushVisit } from '../../components/prescriptionPad/rightPanel/finishScreen/FinishedPanel';
import { finishPrescription, updateDraftId } from '../../store/actions/prescriptionPad';
import {
    getPrescription,
    getPrintConfigs,
    getTranslate,
} from '../../store/selectors/prescriptionPad';
import { track } from '../../tracking';
import {
    GO_TO_NEW_APPOINTMENT,
    GO_TO_PRESCRIPTION_PAD_V2,
    PPRouterProps,
} from '../../routes/paths';
import { his } from '../history';
import {
    getGenieSetting,
    getIsNotesMode,
    getPxElementConfig,
    getSectionNameConfig,
} from '../../store/selectors/session';
import { GlobalStateV1 } from '../../store/reducers';
import { GeniePadElementsSettingItem, MessageConfigType } from '../../api/pushGenie';
import triggerVisitSMS from '../../api/triggerVisitSMS';
import { MESSAGE_CONFIG_ID } from '../../constants';
import { ALREADY_SAVED, createBETool, LATEST_DRAFT_NOT_APPLIED } from '../../api/pushVisit';
import { showOverrideVisitDialog } from '../../components/common/overrideVisitDialog';
import { isForRxMonetisation } from '../utils';
import pushPxDraft from '../../api/pushPxDraft';
import { setDontAllowStartVisit, setIsNotesMode } from '../../store/actions/session';
import { rxWithoutLatestDraft } from '../../components/common/rxWithoutLatestDraft';

const BlockHistory: React.FC = () => {
    const px = useSelector(getPrescription);
    const pc = useSelector(getPrintConfigs);
    const medElements = useSelector((state: GlobalStateV1) =>
        getGenieSetting(state, 'medElements'),
    ) as GeniePadElementsSettingItem[];
    const padElementsConfig = useSelector(getPxElementConfig);
    const sectionNameConfig = useSelector(getSectionNameConfig);
    const isNotesMode = useSelector(getIsNotesMode);
    const [force, setForce] = useState(false);
    const [ignoreDraft, setIgnoreDraft] = useState(false);

    const messageConfig = useSelector(
        (state) => getGenieSetting(state as GlobalStateV1, 'messageConfig') as MessageConfigType[],
    );

    const delayed_rx_message = messageConfig?.find(
        (conf) => conf.id === MESSAGE_CONFIG_ID.RX_DELAYED_WHATSAPP_MESSAGE,
    )?.status;

    const translate = useSelector(getTranslate);
    const dispatch = useDispatch();
    const params: PPRouterProps = useParams();

    const [isHandled, sethandled] = useState(false);

    const pushToCloud = () => {
        if (!px) {
            return;
        }
        pushPxDraft(px.id, px.visitId, createBETool(px)).then((r) => {
            batch(() => {
                if (r.success && r.draftId) {
                    dispatch(updateDraftId(r.draftId));
                }
            });
        });
    };

    useEffect(() => {
        const unblock = his.block((tx) => {
            const handleNotesViewCancelClick = () => {
                unblock();
                his.push({
                    pathname: tx.pathname,
                    state: tx.state,
                });
            };
            const handleNotesViewOkClick = async () => {
                await pushToCloud();
                unblock();
                his.push({
                    pathname: tx.pathname,
                    state: tx.state,
                });
            };
            const route = getCurrentRouteAndParams(tx.pathname, tx.search);
            const urlParams = new URLSearchParams(tx.search);

            if (
                route?.params?.cId &&
                GO_TO_NEW_APPOINTMENT(route?.params?.cId).includes(tx.pathname) &&
                params.pxState === 'finish'
            ) {
                return;
            }

            const forceUrlParam = urlParams.get('force');

            if (forceUrlParam === 'true' || isHandled || !getIsPageBlocked()) {
                return;
            }

            if (!delayed_rx_message && params.pxState === 'finish') {
                return;
            }

            if (
                route?.key !== 'padV1' &&
                route?.key !== 'padV2' &&
                route?.key !== 'padV3' &&
                route?.key !== 'borrow'
            ) {
                sethandled(true);

                let t: any;

                if (params.pxState === 'finish') {
                    t = Modal.confirm({
                        title: 'Do you want to send Rx?',
                        okText: 'Yes',
                        cancelText: 'No',
                        okButtonProps: { className: 'primary-btn font-lato' },
                        cancelButtonProps: { className: 'neutral-btn font-lato' },
                        visible: true,
                        keyboard: true,
                        closable: true,
                        onOk: async () => {
                            if (!px) {
                                track('ERROR', {
                                    on: 'triggerSendRxMessage',
                                    what: `px/pc/tranlate is undefined px:${px === undefined} pc:${
                                        pc === undefined
                                    } translate:${translate === undefined}`,
                                });

                                alert('Failed to send Rx message');
                                return;
                            }
                            triggerVisitSMS(px?.visitId)
                                .then(() => {
                                    his.push({
                                        pathname: tx.pathname,
                                        state: tx.state,
                                    });
                                })
                                .catch((error) => {
                                    unblock();

                                    if (error) {
                                        alert(error.message);
                                    }

                                    alert('Failed to send Rx message.');
                                });

                            t.update({
                                okButtonProps: {
                                    loading: true,
                                    className: 'primary-btn font-lato cursor-pointer',
                                },
                            });

                            setTimeout(() => {
                                const el: HTMLDivElement = document.getElementsByClassName(
                                    'ant-modal-wrap',
                                )[0] as HTMLDivElement;
                                el?.focus();
                            }, 200);
                        },
                        onCancel: (args) => {
                            if (args?.triggerCancel) {
                                track('RX_MESSAGE_SEND_CANCEL', { padPxId: px?.id });
                                sethandled(false);
                                return;
                            }

                            unblock();

                            his.push({
                                pathname: tx.pathname,
                                state: tx.state,
                            });

                            t.destroy();
                            return;
                        },
                        bodyStyle: { padding: '24px' },
                    });
                } else {
                    t = Modal.confirm({
                        title: isNotesMode
                            ? 'Do you want to save changes?'
                            : 'Do you want to end this visit?',
                        okText: 'Yes',
                        cancelText: 'No',
                        okButtonProps: { className: 'primary-btn font-lato' },
                        cancelButtonProps: { className: 'neutral-btn font-lato' },
                        visible: true,
                        keyboard: true,
                        closable: true,
                        onOk: isNotesMode
                            ? () => {
                                  handleNotesViewOkClick();
                                  t.destroy();
                              }
                            : async () => {
                                  track('PAD_SAVE_OK', { padPxId: px?.id });
                                  if (!px) {
                                      track('ERROR', {
                                          on: 'triggerPushVisit',
                                          what: `px/pc/tranlate is undefined px:${
                                              px === undefined
                                          } pc:${pc === undefined} translate:${
                                              translate === undefined
                                          }`,
                                      });
                                      alert(
                                          'Failed to save prescription on cloud. You can complete prescription anytime from patient details page.',
                                      );
                                      return;
                                  }
                                  dispatch(finishPrescription(px));

                                  t.update({
                                      okButtonProps: {
                                          loading: true,
                                          className: 'primary-btn font-lato cursor-pointer',
                                      },
                                  });

                                  setTimeout(() => {
                                      const el: HTMLDivElement = document.getElementsByClassName(
                                          'ant-modal-wrap',
                                      )[0] as HTMLDivElement;
                                      el?.focus();
                                  }, 200);

                                  await new Promise(async (res) => {
                                      try {
                                          await triggerPushVisit(
                                              px,
                                              pc,
                                              translate,
                                              undefined,
                                              undefined,
                                              undefined,
                                              (error) => {
                                                  unblock();

                                                  if (error) {
                                                      alert(error.message);
                                                  }

                                                  his.push({
                                                      pathname: tx.pathname,
                                                      state: tx.state,
                                                  });
                                              },
                                              undefined,
                                              undefined,
                                              undefined,
                                              undefined,
                                              isForRxMonetisation(),
                                              medElements,
                                              padElementsConfig,
                                              sectionNameConfig,
                                              undefined,
                                              ignoreDraft,
                                              px.meta?.draftId,
                                          );
                                          res(true);
                                      } catch (e) {
                                          if ((e as Error).message === ALREADY_SAVED) {
                                              showOverrideVisitDialog(
                                                  async () => {
                                                      t.update({
                                                          okButtonProps: {
                                                              loading: true,
                                                          },
                                                      });
                                                      await triggerPushVisit(
                                                          px,
                                                          pc,
                                                          translate,
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          (error) => {
                                                              unblock();

                                                              if (error) {
                                                                  alert(error.message);
                                                              }

                                                              his.push({
                                                                  pathname: tx.pathname,
                                                                  state: tx.state,
                                                              });
                                                          },
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          true,
                                                          isForRxMonetisation(),
                                                          medElements,
                                                          padElementsConfig,
                                                          sectionNameConfig,
                                                          undefined,
                                                          ignoreDraft,
                                                          px.meta?.draftId,
                                                      );
                                                      res(true);
                                                      setForce(true);
                                                  },
                                                  () => {
                                                      unblock();
                                                      his.push({
                                                          pathname: tx.pathname,
                                                          state: tx.state,
                                                      });
                                                      res(true);
                                                      setForce(false);
                                                  },
                                              );
                                          } else if (
                                              (e as Error).message === LATEST_DRAFT_NOT_APPLIED
                                          ) {
                                              rxWithoutLatestDraft(
                                                  async () => {
                                                      window.location.href = GO_TO_PRESCRIPTION_PAD_V2(
                                                          px.id,
                                                          'edit',
                                                      );
                                                  },
                                                  async () => {
                                                      t.update({
                                                          okButtonProps: {
                                                              loading: true,
                                                          },
                                                      });
                                                      await triggerPushVisit(
                                                          px,
                                                          pc,
                                                          translate,
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          (error) => {
                                                              unblock();

                                                              if (error) {
                                                                  alert(error.message);
                                                              }

                                                              his.push({
                                                                  pathname: tx.pathname,
                                                                  state: tx.state,
                                                              });
                                                          },
                                                          undefined,
                                                          undefined,
                                                          undefined,
                                                          force,
                                                          isForRxMonetisation(),
                                                          medElements,
                                                          padElementsConfig,
                                                          sectionNameConfig,
                                                          undefined,
                                                          true,
                                                          px.meta?.draftId,
                                                      );
                                                      setIgnoreDraft(true);
                                                      res(true);
                                                  },
                                              );
                                          }
                                      }
                                  });
                              },
                        onCancel: isNotesMode
                            ? (args) => {
                                  if (args?.triggerCancel) {
                                      track('PAD_SAVE_CANCEL_DIALOG', { padPxId: px?.id });
                                      sethandled(false);
                                      return;
                                  }
                                  handleNotesViewCancelClick();
                                  t.destroy();
                              }
                            : (args) => {
                                  if (args?.triggerCancel) {
                                      track('PAD_SAVE_CANCEL_DIALOG', { padPxId: px?.id });
                                      sethandled(false);
                                      return;
                                  }

                                  track('PAD_SAVE_CANCEL', { padPxId: px?.id });
                                  unblock();

                                  his.push({
                                      pathname: tx.pathname,
                                      state: tx.state,
                                  });

                                  t.destroy();
                                  return;
                              },
                        bodyStyle: { padding: '24px' },
                    });
                }

                t.update({
                    okButtonProps: { className: 'primary-btn font-lato cursor-pointer' },
                    cancelButtonProps: { className: 'neutral-btn font-lato cursor-pointer' },
                });

                setTimeout(() => {
                    const el: HTMLDivElement = document.getElementsByClassName(
                        'ant-modal-wrap',
                    )[0] as HTMLDivElement;
                    el?.focus();
                }, 200);

                return false;
            }

            return;
        });

        return () => {
            unblock();
        };
    });
    return null;
};

export default BlockHistory;
